/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { MimeTypes } from '../types/utils';
import { FileID } from './file-model';

export class CreateFileInput {
	id: FileID = ''

	isFeatured?: boolean

	mimeType?: MimeTypes

	name?: string

	title?: string
}